import React from 'react';
//import { Route, Routes} from 'react-router-dom';
import { Routes, Route, Navigate } from "react-router-dom";

import HtmlRouter from './htmlRouter';
//import FrontRouter from './frontRouter'; {/* 20250218 퍼블 수정 : 중첩 호출로 Html, Front CSS 충돌 발생하여 임시 수정  */}


function AppRouter() {
	
  return (
		<>
				<Routes>
          <Route path="/" element={<Navigate to='/Html' />} /> 
					<Route path="/Html/*" element={<HtmlRouter />} />
					{/*<Route path="/Front/*" element={<FrontRouter />} />*/} {/* 20250218 퍼블 수정 : 중첩 호출로 Html, Front CSS 충돌 발생하여 임시 수정  */}
				</Routes>

		</>
  );
}

export default AppRouter;
